import { Route } from 'react-router-dom';
import Auth from '../layouts/Auth';
import Login from '../pages/Login';
import Signup from '../pages/public/Signup';
import Kyc from '../pages/public/Kyc';
import Confirm from '../pages/public/Confirm';
import Welcome from '../pages/public/Welcome';
import ForgotPassword from '../pages/public/ForgotPassword';
import ResetPassword from '../pages/public/ResetPassword';

/**
 * Rutas de autenticación - compartidas por admin, shop, fleet
 * Retorna un array de Route elements para usar con spread en Routes
 */
export const authRoutes = (
  <Route path="auth" element={<Auth />}>
    <Route index element={<Login />} />
    <Route path="login" element={<Login />} />
    <Route path="register" element={<Signup />} />
    <Route path="set-up" element={<Kyc />} />
    <Route path="confirm" element={<Confirm />} />
    <Route path="welcome" element={<Welcome />} />
    <Route path="forgot-password" element={<ForgotPassword />} />
    <Route path="reset-password/:id/:token" element={<ResetPassword />} />
    <Route path="*" element={<Login />} />
  </Route>
);
